module.exports = __webpack_public_path__ + "img/image50.1acc8ef6.png";